export { renderAccordionHeader_unstable as renderAccordionHeader } from '@fluentui/react-accordion';
